import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

// Filtros da lista de contas, declarados uma vez (P01). Leve: entra no `validateSearch` da rota.

/** "Tipo de conta" (`DataTableFilters/BankAccountFilters/constants.ts:37-42`, `typeAccountOperator`). */
/* eslint-disable lingui/no-unlocalized-strings -- valores técnicos do fio */
export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'EscrowAccount', label: msg`Conta escrow` },
  { value: 'PaymentAccount', label: msg`Conta de pagamento` },
  { value: 'EscrowPlusAccount', label: msg`Escrow +` },
  { value: 'EscrowMulticreditorsAccount', label: msg`Escrow multicredores` },
] as const;
/* eslint-enable lingui/no-unlocalized-strings */

/** "Encerradas" (`BankAccountFilters.tsx:47-53`, `selectOptionsYesOrNo`): o fio leva `true`/`false`. */
export const YES_NO_OPTIONS = [
  { value: 'true', label: msg`Sim` },
  { value: 'false', label: msg`Não` },
] as const;

/** "Número da conta": só dígitos, até 12 (`BankAccountFilters.tsx:154-166`). */
export const accountNumberParam = (value: string) => value.replace(/\D/g, '').slice(0, 12);

/**
 * `availableFilters` da lista (`BankAccountListContainer.tsx:57-77`) e as opções do "Filtrar por"
 * (`BankAccountFilters.tsx:69-79`). "Encerradas" só no tenant raiz: a tela usa `pick`.
 */
export const bankAccountListFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'f_personName', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
  { key: 'f_personRegistrationNumber', type: 'document', label: msg`CPF/CNPJ`, placeholder: msg`Filtrar por CPF/CNPJ` },
  { key: 'f_account', type: 'text', label: msg`Número da conta`, placeholder: msg`Filtrar por número da conta`, max: 12, toParam: accountNumberParam },
  { key: 'f_type', type: 'select', label: msg`Tipo de conta`, options: ACCOUNT_TYPE_OPTIONS },
  { key: 'isDeleted', type: 'select', label: msg`Encerradas`, options: YES_NO_OPTIONS },
]);

/** Sem o "Encerradas", para o parceiro (`BankAccountFilters.tsx:77-79`). */
export const partnerBankAccountListFilters = bankAccountListFilters.pick('searchString', 'f_personName', 'f_personRegistrationNumber', 'f_account', 'f_type');
